module.exports = __webpack_public_path__ + "img/product_info.0cdbba60.jpg";